<template>
  <div>
    <app-layout :title="title">
      <PageTitle :headerTitle="title"> </PageTitle>
      <br />
      <!-- <template v-slot:tcsetttingnav>
    </template>
     <template v-slot:tcmainnav>
    </template>
    -->
      <template v-slot:adminnav> </template>
      <div class="max-w-4xl mx-auto">
        <div
          v-if="moduleRoute === 'users'"
          class="grid grid-cols-6 gap-1 text-center mt-1 mb-1"
        >
          <!-- If users then nothing will be rendered -->
        </div>

        <div
          v-else-if="moduleRoute === 'audits'"
          class="grid grid-cols-6 gap-1 text-center mt-1 mb-1"
        >
          <!-- If audits then nothing will be rendered -->
        </div>
        <jet-button
          v-else
          class="
            bg-blue-500
            rounded
            text-white
            hover:bg-blue-500 hover:no-underline
            px-2
            cursor-pointer
            text-sm
          "
          @click="goToCreate"
        >
          Add {{ moduleName }}</jet-button
        >
      </div>

      <div class="max-w-4xl mx-auto sm:px-8 lg:px-10 mt-2">
        <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <!-- <div class="text-lg font-bold ">Create {{moduleName}}</div> -->
          <TcBsIndex :slug="slug" :routeDef="moduleRoute" :headersDef="headers">
          </TcBsIndex>
        </div>
      </div>
    </app-layout>
  </div>
</template>

<style>
.grey-background-container {
  /* background-color:#ffffff; */
  /* height:100%; */
}
/* .b_edit{
  width: 45rem;
} */

/* .DxDataGrid{
  width: 800px !important;
} */

.max-w-4xl {
  width: 55rem !important;
}
</style>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import TcBsIndex from "@/Base/TcBsIndex.vue";
import MobileBsIndex from "@/Base/MobileBsIndex.vue";
//import { DxDataGrid } from 'devextreme-vue/data-grid';
import DataSource from "devextreme/data/data_source";
import "devextreme/data/odata/store";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetButton from "@/Jetstream/Button.vue";
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import MobileNavigationBack from "@/Layouts/MobileNavigationBack.vue";

let collapsed = false;

export default {
  props: {
    moduleRoute: String,
    headers: Array,
    moduleName: String,
    slug: String,
  },
  components: {
    AppLayout,
    TcBsIndex,
    PageTitle,
    JetNavLink,
    JetButton,
    MobileNavigation,
    MobileBsIndex,
    MobileNavigationBack,
  },
  data() {
    return {
      title: this.moduleName,
      dataSource: new DataSource({
        store: {
          type: "odata",
          url: "https://js.devexpress.com/Demos/SalesViewer/odata/DaySaleDtoes",
          key: "Id",
          beforeSend: function (request) {
            request.params.startDate = "2020-05-10";
            request.params.endDate = "2020-05-15";
          },
        },
      }),
      grouping: {
        contextMenuEnabled: true,
        autoExpandAll: false,
        expandMode: "rowClick",
      },
      groupPanel: {
        visible: true,
      },
      columns: ["Product", "Region", "SaleDate", "Channel", "Customer"],
      pageSizes: [10, 25, 50, 100],
      onContentReady: function (e) {
        if (!collapsed) {
          e.component.expandRow(["EnviroCare"]);
          collapsed = true;
        }
      },
    };
  },
  methods: {
    sayHelloWorld() {
      alert("Hello world!");
    },
    goToCreate() {
      this.$inertia.get("/" + this.slug + "/" + this.moduleRoute + "/create");
    },
    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        console.log("CheckMobile Called: Mobile");
        return true;
      } else {
        console.log("CheckMobile Called: Desktop");
        return false;
      }
    },
  },
  data: function () {
    return {
      title: this.moduleRoute,
      appbarTitle: this.moduleRoute,
    };
  },
  mounted() {
    // this.checkMobile();
  },
};
</script>
